import React from 'react'
import styles from './DesktopChallanPPED.module.scss'

const NoChallanFound = () => (
  <div className={styles.noChallanFound}>
    <div className={styles.successIconWrap}>
      <img src="https://acko-cms.ackoassets.com/Success_cf25f88430.svg" />
    </div>
    <div className={styles.noChallanTitle}>No challans found</div>
    <div className={styles.zeroChallanBanner}>Zero challans = lower insurance price</div>
  </div>
)

export default NoChallanFound
